import React, {MutableRefObject} from "react";
import {TextField, Button, Grid, IconButton} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";

interface NewPromptInputProps {
  prompt: string;
  setPrompt: (string) => void;
  generateLlmPrompt: () => void;
  isLoading: boolean;
  textFieldRef: MutableRefObject<HTMLInputElement | null>;
  compact?: boolean;
}

export function NewPromptInput({
  prompt,
  setPrompt,
  generateLlmPrompt,
  isLoading,
  textFieldRef,
  compact,
}: NewPromptInputProps) {
  const canSend = !isLoading && Boolean(prompt.trim());
  const textField = (
    <TextField
      fullWidth
      inputRef={input => (textFieldRef.current = input)}
      disabled={isLoading}
      value={prompt}
      multiline
      variant="outlined"
      size={compact ? "small" : "medium"}
      autoFocus
      onChange={event => setPrompt(event.target.value)}
      onKeyDown={event => {
        if (event.key === "Enter" && !event.shiftKey && prompt.trim()) {
          event.preventDefault();
          generateLlmPrompt();
        }
      }}
      style={{flexGrow: 1}}
    />
  );
  if (compact) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          width: "100%",
        }}
      >
        {textField}
        <IconButton
          color="primary"
          size="small"
          title="Send"
          disabled={!canSend}
          onClick={() => generateLlmPrompt()}
        >
          <SendIcon />
        </IconButton>
      </div>
    );
  }
  return (
    <>
      <Grid item xs={10}>
        {textField}
      </Grid>
      <Grid item xs={2}>
        <Button
          color="primary"
          fullWidth
          style={{height: "100%", borderRadius: "4px"}}
          variant="contained"
          disabled={!canSend}
          onClick={() => {
            generateLlmPrompt();
          }}
        >
          Send
        </Button>
      </Grid>
    </>
  );
}
